import { Inline, Text } from "@contentful/rich-text-types";
import React from "react";
import ExternalLink from "../ExternalLink";
import { RichTextReference } from "./types";

type Props = {
  assets: RichTextReference[];
  node: Inline;
};

export default function AssetHyperlink({ assets, node }: Props) {
  const { file } = node.data.target.fields;
  const asset = assets.find((x) => x.sourceUrl === file.url);
  if (!asset) {
    throw new Error("Asset is not of the correct type.");
  }

  const href = asset.localFile?.publicURL;
  if (!href) {
    throw new Error(
      "There is an asset hyperlink in the rich-text but you have not queried the `publicURL`."
    );
  }

  const content = node.content[0] as Text;
  return (
    <ExternalLink href={href} showExternalIcon={false}>
      {content.value}
    </ExternalLink>
  );
}
